const habitImages = [
  '/assets/img/habits/1.png',
  '/assets/img/habits/2.png',
  '/assets/img/habits/3.png',
];

export const getHabitImageByID = (habitId: string): string => {
  if (habitId === 'program-intro') {
    return '/assets/img/modules/1.png';
  }
  // Use the habit ID to consistently assign the same image
  const hash = habitId.split('').reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);
  const index = Math.abs(hash) % habitImages.length;
  return habitImages[index];
};

export const getHabitImageUrl = (habitIconUrl?: string | null, habitId?: string): string => {
  if (habitIconUrl) {
    return habitIconUrl;
  }
  if (habitId) {
    return getHabitImageByID(habitId);
  }
  // Fallback to first image if no habit ID is provided
  return habitImages[0];
};